import { CommentsGroup } from "../../community/utils/CommentsGroup";
import { GroupDate } from "../../community/utils/DateTransform";
import { CommentsMessagesModel } from "../models/CommentsMessagesModel";
import { CommentsMessageItem } from "./CommentsMessageItem";

type Props = {
    comments: CommentsMessagesModel[];
    onReact: (comment: CommentsMessagesModel) => void;
    onReply: (comment: CommentsMessagesModel) => void;
    onEdit?: (comment: CommentsMessagesModel) => void;
    onDelete?: (comment: CommentsMessagesModel) => void;
    renderBody?: (comment: CommentsMessagesModel) => React.ReactNode;
    /**
     * Id del usuario que ancla el chip HOST en este hilo. Sin este prop, `CommentsMessageItem`
     * mantiene la regla previa (`comment.isMine`) — solo cambia el comportamiento para los
     * hilos que lo declaran explicitamente (hoy Expertise).
     */
    hostUserId?: number | null;
}

export const CommentsMessagesWrap = ({ comments, onReact, onReply, onEdit, onDelete, renderBody, hostUserId }: Props) => {
    if(comments.length <= 0)
        return <></>

    const _commentsByDate = CommentsGroup(comments);
    return (
        <>
        {Object.keys(_commentsByDate).map((date, i) => (
            <div key={date} style={{ display: 'flex', flexDirection: 'column-reverse', gap: '40px', width: '100%' }}>
                {
                    _commentsByDate[date].map((c, i) => (
                        <CommentsMessageItem
                            key={`${i}_${c.id}`}
                            comment={c}
                            onReply={() => onReply(c)}
                            onReact={() => onReact(c)}
                            onEdit={onEdit ? () => onEdit(c) : undefined}
                            onDelete={onDelete ? () => onDelete(c) : undefined}
                            renderBody={renderBody}
                            hostUserId={hostUserId}
                        />
                    ))
                }
                <div className="community-separator">
                    <svg xmlns="http://www.w3.org/2000/svg" width="372" height="1" viewBox="0 0 372 1" fill="none">
                        <path d="M0 0.5H372" stroke="#E9E9E9"/>
                    </svg>
                    <span style={{ whiteSpace: "nowrap" }}>
                        {GroupDate(date)}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="372" height="1" viewBox="0 0 372 1" fill="none">
                        <path d="M0 0.5H372" stroke="#E9E9E9"/>
                    </svg>
                </div>
            </div>
        ))}
        </>
    )
}